import { useEffect } from "react";
import { trackEvent } from "../lib/analytics";

// [section id, friendly name] — fires a GA4 `section_view` event the first
// time each section scrolls into the upper portion of the viewport.
const SECTIONS = [
  ["top", "Hero"],
  ["logos", "Logo Marquee"],
  ["services", "Services"],
  ["case-study", "Case Study"],
  ["work", "Our Work"],
  ["testimonials", "Testimonials"],
  ["about", "About"],
  ["get-started", "Get Started Form"],
  ["contact", "Contact"],
];

export function useSectionViews() {
  useEffect(() => {
    const seen = new Set();
    const names = new Map(SECTIONS);

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          const id = entry.target.id;
          if (entry.isIntersecting && !seen.has(id)) {
            seen.add(id);
            trackEvent("section_view", {
              section_id: id,
              section_name: names.get(id) || id,
            });
          }
        });
      },
      { threshold: 0, rootMargin: "0px 0px -45% 0px" }
    );

    SECTIONS.forEach(([id]) => {
      const el = document.getElementById(id);
      if (el) observer.observe(el);
    });

    return () => observer.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps -- mount-only observer; SECTIONS is a module constant, rest are globals
  }, []);
}
